// Firebase MUST be initialized before any @batical/* import (they call getApp() at module level)
import 'src/shims/firebase'

import { initDevMobileConsole } from 'src/devMobileConsole'

initDevMobileConsole()

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import configureStore, { persistor } from '@batical/reducer/src/store/setup'
import theme from './theme'
import { router } from './router'
import { AuthProvider } from './contexts/AuthContext'
import '@batical/i18n'

// Auto-reload when a dynamic import fails because the hashed chunk was replaced by a new deploy.
// SessionStorage guard prevents infinite reload loops if the resource is genuinely missing.
window.addEventListener('vite:preloadError', () => {
  if (!sessionStorage.getItem('vite-stale-chunk-reload')) {
    sessionStorage.setItem('vite-stale-chunk-reload', '1')
    window.location.reload()
  }
})

const store = configureStore.store

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <HelmetProvider>
            <AuthProvider>
              <RouterProvider router={router} />
            </AuthProvider>
          </HelmetProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </StrictMode>
)
